import BlogArticleContent from "./BlogArticleContent";
import BlogArticleHeader from "./BlogArticleHeader";
import BodyTextMedium from "./BodyTextMedium";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import Layout from "./Layout";
import PageContent from "./PageContent";
import React from "react";
import ResponsiveImage from "./ResponsiveImage";

function BlogArticlePage({ pageData, navItems, globalData }) {
  return (
    <Layout navItems={navItems} globalData={globalData}>
      <PageContent>
        <BlogArticleHeader
          title={pageData.title}
          published={pageData.published}
        />
        <BoxWithGutter pb={[80, null, 160, null]}>
          <Box maxWidth={740} mx="auto">
            <Box mt={[30, null, 90, null]}>
              <ResponsiveImage
                resizeRule="fill-1480x728-c0"
                image={pageData.headerImage}
                pb="50%"
              />
            </Box>
            <Box mt={[30, null, 90, null]}>
              <BodyTextMedium>{pageData.introCopy}</BodyTextMedium>
            </Box>
            <BlogArticleContent content={pageData.content} />
          </Box>
        </BoxWithGutter>
      </PageContent>
    </Layout>
  );
}

export default BlogArticlePage;
